import isEmpty from 'lodash/isEmpty';
import { ControlProps } from '@jsonforms/core';
import { Form } from 'antd';
import { Hidden } from '@components/uploadForm/renderers/views/Hidden';
import { AntdToggle } from '@components/uploadForm/renderers/views/AntdToggle';

export const BooleanToggleControl = ({
  data,
  visible,
  label,
  id,
  enabled,
  uischema,
  schema,
  rootSchema,
  handleChange,
  errors,
  path,
  config,
}: ControlProps) => {
  const isValid = isEmpty(errors);

  return (
    <Hidden hidden={!visible}>
      <Form.Item
        hidden={!visible}
        label={label}
        id={id}
        hasFeedback={!isValid}
        help={!isValid ? errors : null}
      >
        <AntdToggle
          id={`${id}-input`}
          isValid={isValid}
          data={data}
          enabled={enabled}
          visible={visible}
          path={path}
          uischema={uischema}
          schema={schema}
          rootSchema={rootSchema}
          handleChange={handleChange}
          errors={errors}
          config={config}
        />
      </Form.Item>
    </Hidden>
  );
};
